import Big from 'big.js'
import { get, writable } from 'svelte/store'
import { debounce } from 'ts-debounce'

import { makeClient } from '$lib/factories'
import { apiPostJson } from '$lib/proxy/apiProxy'
import type { Client, ClientListItem } from '$lib/types/client_types'

import { parseClientList } from '../parsers'

const emptyParameters = {
	archived: [false],
	query: '',
	withName: true,
	clientId: ''
}

export const clientsParameters = writable({ ...emptyParameters })
export const clients = writable([] as ClientListItem[])

export const resetClients = () => {
	clients.set([])
	clientsParameters.set({ ...emptyParameters })
}

let controller: AbortController

export async function getClients(clientsParams: any) {
	if (controller) {
		controller.abort()
	}
	controller = new AbortController()
	const signal = controller.signal

	const parameters = clientsParams
	const jsonData = await apiPostJson(
		'/clients',
		{
			archived: parameters.archived,
			query: parameters.query,
			withName: parameters.withName,
			client_id: parameters.clientId
		},
		signal
	)

	// Check if cancelled by AbortController
	if (jsonData === null) return null
	if (jsonData?.error) {
		return
	}
	return parseClientList(jsonData.clients)
}

export async function fetchClients() {
	const parameters = get(clientsParameters)
	const jsonData = await apiPostJson('/clients', {
		archived: parameters.archived,
		query: parameters.query,
		withName: parameters.withName,
		client_id: parameters.clientId
	})
	if (jsonData?.error) {
		return
	}
	clients.set(parseClientList(jsonData.clients))
}

export const debouncedFetchClients = debounce(fetchClients, 400)

// export const debouncedFetchClients = debounce(fetchClients, 50, {
// 	isImmediate: true,
// 	maxWait: 100
// });

// removed beacuse list of clients now is only used in ClientList
// checkThis.subscribe((toCheck) => {
// 	if (toCheck.includes('clients')) {
// 		debouncedFetchClients();
// 	}
// });

export const getClientFromListItem = (clientLI: ClientListItem | undefined): Client => {
	let cli: Client

	if (typeof clientLI === 'undefined' || clientLI.id === 'new-client') 
		cli = makeClient()
	else {
		cli = {
			account_id: '',
			address_1: clientLI.address_1,
			address_2: clientLI.address_2,
			archived: clientLI.archived,
			city: clientLI.city,
			country: clientLI.country,
			email: clientLI.email,
			id: clientLI.id,
			name: clientLI.name,
			phone: clientLI.phone,
			postal_code: clientLI.postal_code,
			state_region: clientLI.state_region,
			language_id: clientLI.language_id,
			information: clientLI.information
		}
	}

	return cli
}

export const convertClientToListItem = (client: Client): ClientListItem => {
	// let cliLI: ClientListItem

	const cliLI: ClientListItem = {
		account_id: '',
		address_1: client.address_1,
		address_2: client.address_2,
		archived: client.archived,
		city: client.city,
		country: client.country,
		country_id: client.country_id,
		language_id: client.language_id,
		email: client.email,
		id: client.id,
		name: client.name,
		phone: client.phone,
		postal_code: client.postal_code,
		state_region: client.state_region,
		information: client.information,
		number_estimates: 0,
		number_invoices: 0,
		grand_total: Big(0),
		paid: Big(0),
		owing: Big(0)
	}

	return cliLI
}
